/* ==========================================================================
   Lille Björn: keep the Shopify Inbox chat bubble out of the way of overlays
   assets/lb-chat-guard.js. Release 1.0.0 (8 Oct 2026). Load on EVERY page,
   with defer, after bundle.js. No stylesheet: the one rule it needs is below.

   The Inbox bubble sits bottom-left at the very top of the page's stacking
   order (z-index 2147483000), so it floats over whatever overlay is open: the
   cart drawer, Quick Shop, the menu, search, the image gallery, the size
   guide, the fit finder, the Personalise popup, the free gift modal and the
   sticky bar's options drawer. While any of them is open, this fades the
   bubble out and makes it untappable; when they close, it comes back. The
   chat itself is never touched: an open chat window is not an "overlay" here.

   How "an overlay is open" is known, in order:
   - the theme's own scroll lock: body.o-hidden (every SHT dialog and drawer:
     cart, menu, search, gallery, size guide, Quick Shop), or an inline
     overflow:hidden on <html>/<body> (the fit finder);
   - named states: html.lbqs-open (Quick Shop), html.lb-sbb-drawer-open (the
     sticky bar's drawer), lillebjorn-fit-finder[data-open];
   - otherwise, anything visible and fixed that covers most of the screen at
     its centre (the Personalise popup, the free gift modal, any future one).
   Checked once per frame at most, only after the page changes.
   ========================================================================== */
(function () {
  'use strict';
  if (window.LBChatGuard) return;

  var CLS = 'lb-chat-hide';
  var style = document.createElement('style');
  style.textContent = 'html.' + CLS + ' shopify-chat{opacity:0!important;pointer-events:none!important;transition:opacity .2s ease}' +
    '@media (prefers-reduced-motion:reduce){html.' + CLS + ' shopify-chat{transition:none}}';
  document.head.appendChild(style);

  var NAMED = 'html.lbqs-open, html.lb-sbb-drawer-open, lillebjorn-fit-finder[data-open]';
  var LOCK = /overflow\s*:\s*hidden/i;

  function coverAtCentre() {
    var x = window.innerWidth / 2, y = window.innerHeight / 2;
    var hits = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
    for (var i = 0; i < hits.length; i++) {
      var el = hits[i];
      if (el.closest && el.closest('shopify-chat')) continue;          /* the chat (and an open chat window) never counts */
      for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
        var cs = getComputedStyle(n);
        if (cs.position === 'fixed') {
          if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
          var r = n.getBoundingClientRect();
          return r.width * r.height >= window.innerWidth * window.innerHeight * 0.5;
        }
      }
      return false;                                                    /* the page itself is on top */
    }
    return false;
  }

  function overlayOpen() {
    var b = document.body, h = document.documentElement;
    if (!b) return false;
    if (b.classList.contains('o-hidden')) return true;
    if (LOCK.test(h.getAttribute('style') || '') || LOCK.test(b.getAttribute('style') || '')) return true;
    if (document.querySelector(NAMED)) return true;
    return coverAtCentre();
  }

  var queued = 0;
  function check() {
    if (queued) return;
    queued = requestAnimationFrame(function () {
      queued = 0;
      document.documentElement.classList.toggle(CLS, overlayOpen());
    });
  }

  new MutationObserver(check).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['class', 'style', 'open', 'data-open', 'hidden', 'aria-hidden']
  });
  window.addEventListener('resize', check, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
  window.LBChatGuard = { version: '1.0.0', check: check };
})();
